<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card>
      <v-alert
        v-model="error"
        dismissible
        type="error"
      >
        {{errorMsg}}
      </v-alert>
      <div>
        <v-card-title class="headline pl-3 py-2 pr-2">
          Usuń użytkownika
          <v-spacer></v-spacer>
          <v-btn
            @click.native="visibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <div v-if="!dialogBusy">
          <div class="scrollable-height">
            <div class="py-4">
              <div class="px-3" v-if="reasons">
                <v-select
                  v-model="reason"
                  :items="reasons"
                  item-text="name"
                  item-value="id"
                  label="Wybierz powód usunięcia użytkownika"
                  :error-messages="errors.collect('reason')"
                  v-validate="'required'"
                  data-vv-name="reason"
                  data-vv-as="powodu usunięcia użytkownika"
                  required
                ></v-select>
              </div>
              <div class="px-3" v-if="adminsList && role === 'admin'">
                <v-select
                  v-model="newAdminId"
                  :items="adminsList"
                  item-text="name"
                  item-value="id"
                  label="Wybierz administratora"
                  :error-messages="errors.collect('newAdminId')"
                  v-validate="'required'"
                  data-vv-name="newAdminId"
                  data-vv-as="nowego administratora"
                  required
                  hint="Wskaż administratora, któremu zostaną przypisane pliki"
                  persistent-hint
                ></v-select>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>

            <v-btn
              color="primary lighten-2"
              flat="flat"
              @click="setVisbility"
            >
              Anuluj
            </v-btn>

            <v-btn
              color="primary"
              :loading="busy"
              :disabled="busy"
              @click="deleteUser"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </div>
        <div v-if="dialogBusy">
          <div class="py-4 text-xs-center">
            <v-progress-circular
              :size="30"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getDeleteUserForm } from '../../../repository/users/index';
import { getError } from '../../../helpers/helpers';

export default {
  name: 'user-delete-dialog',
  data: () => ({
    busy: false,
    reasons: null,
    reason: null,
    newAdminId: null,
    errorMsg: null,
    error: false,
    adminsList: null,
    dialogBusy: false,
  }),
  computed: {
    ...mapGetters('users', [
      'dialogVisibility',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'delete';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
    userId() {
      return this.dialogVisibility.id;
    },
    role() {
      return this.dialogVisibility.role;
    },
  },
  methods: {
    ...mapActions('users', [
      'setDialogVisbility',
      'userDelete',
    ]),
    getAdminsList(adminsList) {
      this.adminsList = adminsList
        .filter(user => user.role === 'admin')
        .map((user) => {
          const newUser = {
            id: user.id,
            name: `${user.first_name} ${user.last_name}`,
          };
          return newUser;
        });
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
    },
    setVisbility() {
      this.setDialogVisbility(false);
    },
    async getFormData() {
      this.dialogBusy = true;
      try {
        const formRes = await getDeleteUserForm(this.userId);
        const formData = formRes.data.data;
        this.getAdminsList(formData.admins);
        this.reasons = formData.delete_reasons;
        this.dialogBusy = false;
        this.roles = formData.roles;
        this.clients = formData.clients;
      } catch (e) {
        this.getError(e);
      }
    },
    async deleteUserInit() {
      this.busy = true;
      this.error = false;
      const userData = {
        id: this.userId,
        data: {
          delete_reason: this.reason,
          new_owner_id: this.newAdminId,
        },
      };
      try {
        await this.userDelete(userData);
        this.busy = false;
        this.setDialogVisbility(false);
      } catch (e) {
        const errorMsg = e.response.data ? e.response.data.status.msg : e;
        this.error = true;
        this.errorMsg = errorMsg || 'Wystąpił nieoczekiwany błąd!';
        this.busy = false;
      }
    },
    deleteUser() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.deleteUserInit();
        }
      });
    },
  },
  watch: {
    visibility(val) {
      if (val === true) {
        this.getFormData();
      }
    },
  },
};
</script>
